import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => {
  // Detectar si es SVG o PNG/JPG
  const isSvg = src.endsWith(".svg");
  const path = isSvg ? `/img/svg/${src}` : `/img/icons/${src}`;

  return <img src={path} alt={src} width={width} height={height} />;
};